import clsx from 'clsx';
import React, { ReactElement } from 'react';

import styles from './optionRow.module.scss';


type ValueEntry<T> = {
  display: string;
  testId?: string;
  value: T;
};

type Props<T> = {
  disabled?: boolean;
  onSelect: ( val: T ) => void;
  options: ValueEntry<T>[];
  title: ReactElement | string;
  value?: T;
};

export default function OptionRow<T>( props: Props<T> ) {
  const {
    disabled = false,
    onSelect,
    options,
    title,
    value
  } = props;

  const OptionEls = (): ReactElement[] => {
    const els: ReactElement[] = [];

    for( const [ i, option ] of Object.entries( options ) ) {
      const testId = option.testId || `metric-type-${ ( option.display as string ).toLowerCase().replace( /\s+as\s+/g, '-as-' ).replace( /\s+/g, '-' ) }`;
      const optionEl = (
        <span
          className={ clsx( styles.option, ( value === option.value ) && styles.selected, disabled && styles.disabled ) }
          key={ `option-${ i }-${ option.value }` }
          onClick={ () => { if( !disabled ) { onSelect( option.value ); } } }
          aria-disabled={ disabled }
          data-testid={ testId }
        >
          { option.display as string }
        </span>
      );

      els.push( optionEl );

      if( parseInt( i ) < options.length - 1 ) {
        els.push( <span key={ `separator-${ i }` }>|</span> );
      }
    }

    return els;
  };

  return (
    <div className={ clsx( 'layout__col', 'pad' ) }>
      <div className='auth_flow_label'>{ title }</div>
      <div className={ clsx( 'layout__row', styles.options_container ) }>
        <OptionEls />
      </div>
    </div>
  );
}